import {lazy} from 'react';
import {createRoute} from '@tanstack/react-router';

const ReportsPage = lazy(() => import(/* webpackChunkName: "Reports" */ './ReportsPage'));

/**
 * `/reports` and any deeper `/reports/*` path render ReportsPage (the page does
 * its own internal routing). Mirrors the RR3 IndexRoute + `*` splat.
 */
export function makeReportsRoute(parentRoute) {
  const reportsRoute = createRoute({getParentRoute: () => parentRoute, path: 'reports'});
  const indexRoute = createRoute({
    getParentRoute: () => reportsRoute,
    path: '/',
    component: ReportsPage
  });
  const splatRoute = createRoute({
    getParentRoute: () => reportsRoute,
    path: '$',
    component: ReportsPage
  });
  return reportsRoute.addChildren([indexRoute, splatRoute]);
}
